export default "__VITE_ASSET__CnbfEi3Q__"